import { formOptions } from "@tanstack/react-form";
import { z } from "zod";

export const feedbackSchema = z.object({
  email: z.string().email("Invalid email"),
  message: z.string().min(10, "Feedback must be at least 10 characters"),
});

export const feedbackFormOpts = formOptions({
  defaultValues: {
    email: "",
    message: "",
  } as z.infer<typeof feedbackSchema>,
});
